import { createTheme } from "@mui/material/styles";

export const PAL = {
  bg: "#f6f7fb",
  paper: "#ffffff",
  ink: "#0b1530",
  inkSoft: "#3d4a6b",
  muted: "#6b7798",
  border: "#e5e8f1",
  borderStrong: "#d6dbe8",
  navy: "#0b2766",
  navySoft: "#1f3a8a",
  accent: "#1565c0",
  accentHover: "#0f4a8c",
  accentSoft: "#e3f2fd",
  good: "#0a8a4f",
  goodSoft: "#e6f5ee",
  gold: "#d4a64a",
  goldSoft: "#f8efe3",
  goldDark: "#8a6b2a",
  warn: "#ed6c02",
  warnSoft: "#fff4e5",
  bad: "#b8442c",
  badSoft: "#f7e9e4",
};

export const TAG_COLORS = [
  { fg: PAL.accent, soft: PAL.accentSoft },
  { fg: PAL.good, soft: PAL.goodSoft },
  { fg: "#6438c4", soft: "#efe9fb" },
  { fg: "#b35900", soft: "#fdefdc" },
  { fg: "#0d6f8d", soft: "#e2f1f6" },
  { fg: PAL.bad, soft: PAL.badSoft },
];

const theme = createTheme({
  palette: {
    primary: {
      main: PAL.accent,
      border: PAL.border,
    },
    secondary: {
      main: "#08090a",
    },
    error: {
      main: PAL.bad,
    },
    background: {
      default: PAL.paper,
    },
  },
  typography: {
    fontFamily: 'Roboto, -apple-system, BlinkMacSystemFont, sans-serif',
  },
});

export default theme;
